import { Matrix } from "pixi.js"
import { SUN } from "../sun"

export const soleLineInFrame = (frameHeight: number, feetY: number): number => frameHeight / 2 + feetY - 32

export const shadowProjection = (height: number, feetY: number, x: number, y: number, sx: number, sy: number, dirX = SUN.x, dirY = SUN.y): Matrix => {
    const feet = soleLineInFrame(height, feetY)
    return new Matrix(sx, 0, -sx * dirX, -sy * dirY, x + feet * sx * dirX, y + feet * sy * (1 + dirY))
}

/** Maps a selected source sole to a stable ground point, regardless of padding or art offsets. */
export const anchoredShadowProjection = (sole: { x: number; y: number }, ground: { x: number; y: number },
    sx = 1, sy = 1, dirX = SUN.x, dirY = SUN.y): Matrix =>
    new Matrix(sx, 0, -sx * dirX, -sy * dirY,
        ground.x - sole.x * sx + sole.y * sx * dirX, ground.y + sole.y * sy * dirY)
